import config from "../../../../config.json";

export default class ImageHelper {

    static getUrl(image) {
        const {path, basename, extension} = image;

        return `${config.url_images}${path}${basename}/${basename}.${extension}`;
    }

    static getVariantUrl(image, variantKey) {
        const {path, basename, extension} = image;

        return `${config.url_images}${path}${basename}/${basename}-${variantKey}.${extension}`;
    }

    static getAttrSrcset(image) {
        // return ImageHelper.getVariants(image).map(t => `${t.url} ${t.key}`).join(', ');
        return '';
    }

    static getAttrSizes(image) {
        return '';
    }

    static getVariants(image) {
        const {variants: variants_json} = image;

        const result = [];

        try {
            const variants = JSON.parse(variants_json);

            for (let key in variants) {
                if (variants.hasOwnProperty(key)) {
                    result.push({
                        key: key,
                        url: ImageHelper.getVariantUrl(image, key),
                        width: variants[key].width,
                        height: variants[key].height,
                    });
                }
            }

        } catch (e) {

            console.log(e);
        }

        return result;
    }
}
